import { defineComponent, ref, watch, nextTick, onUnmounted, computed } from "vue";
export default defineComponent({
    props: {
        projectName: {
            type: String,
            default: ""
        },
        textMaxLength: {
            type: Number,
            default: 60
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var projectNameChangeHandler = function projectNameChangeHandler(v) {
            if (v === "" || v.length > props.textMaxLength || v === originName) {
                editingName.value = originName;
                return;
            }
            emit("updateProjectName", v, originName);
        };
        var blurHandler = function blurHandler() {
            isEditing.value = false;
        };
        var clickHandler = function clickHandler() {
            isEditing.value = true;
            originName = props.projectName;
            nextTick(function() {
                var _$ref;
                (_$ref = inputRef.value) === null || _$ref === void 0 ? void 0 : _$ref.focus();
            });
        };
        var keyDownHandler = function keyDownHandler(e) {
            if (e.code === "Enter") {
                var _$ref;
                (_$ref = inputRef.value) === null || _$ref === void 0 ? void 0 : _$ref.blur();
            } else if (e.code === "Escape") {
                editingName.value = originName;
                nextTick(function() {
                    var _$ref;
                    (_$ref = inputRef.value) === null || _$ref === void 0 ? void 0 : _$ref.blur();
                });
            }
        };
        var inputRef = ref();
        var editingName = ref("");
        var isEditing = ref(false);
        var isWarn = computed(function() {
            return editingName.value.length === 0 || editingName.value.length > props.textMaxLength;
        });
        var originName = "";
        watch(function() {
            return props.projectName;
        }, function(value) {
            editingName.value = value;
        });
        window.addEventListener("keydown", keyDownHandler);
        onUnmounted(function() {
            window.removeEventListener("keydown", keyDownHandler);
        });
        return {
            isEditing: isEditing,
            editingName: editingName,
            inputRef: inputRef,
            isWarn: isWarn,
            projectNameChangeHandler: projectNameChangeHandler,
            blurHandler: blurHandler,
            clickHandler: clickHandler
        };
    }
});
